export default __webpack_public_path__ + "static/media/library.5ba38d2b.jpg";